<template>
  <header class="flex">
    <div>
      <feather-icon
        icon="ArrowLeftCircleIcon"
        svgClasses="h-8 w-8"
        class="p-2"
        v-if="allowBack"
        @click="goBack"
      />
    </div>
    <div class="flex-grow">
      <img
        class="header-logo"
        :src="require('@app/assets/images/header-logos.jpg')"
      />
      <h1 class="text-black md:text-4xl text-bold leading-9 text-center mb-2">STATUS OF KALU GANGA RIVER</h1>
    </div>
    <div>
    </div>
  </header>
</template>

<script>
import Clock from "./Clock.vue";
export default {
  components: { Clock },
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
    allowBack: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style scoped>
.header-logo {
  width: 480px;
  margin: 0 auto;
  display: block;
  margin-bottom: 20px;
}
</style>